import type { ScoreCategory, ScoreEntry } from '../game/types'
import type { Translator } from '../i18n'

interface Props {
  category: ScoreCategory
  onCategory: (category: ScoreCategory) => void
  scores: ScoreEntry[]
  loading: boolean
  error: boolean
  t: Translator
}

export function Leaderboard({ category, onCategory, scores, loading, error, t }: Props) {
  return <section className="leaderboard" aria-labelledby="leaderboard-title">
    <div className="section-heading">
      <div><span className="eyebrow">LIVE / GLOBAL</span><h2 id="leaderboard-title">{t('leaderboard')}</h2></div>
      <span className="live-dot" aria-hidden="true" />
    </div>
    <div className="score-tabs" role="tablist">
      {(['official', 'custom'] as ScoreCategory[]).map((tab) => <button key={tab} type="button" role="tab" aria-selected={category === tab} onClick={() => onCategory(tab)}>{t(tab)}</button>)}
    </div>
    <p className="ranking-hint">{t(category === 'official' ? 'rankHint' : 'customHint')}</p>
    <div className="score-list" role="list" aria-busy={loading}>
      {loading && <p className="empty-score">{t('loading')}</p>}
      {!loading && error && <p className="empty-score">{t('offline')}</p>}
      {!loading && !error && scores.length === 0 && <p className="empty-score">{t('empty')}</p>}
      {!loading && scores.slice(0, 10).map((entry, index) => <div className="score-row" role="listitem" key={entry.id}>
        <span className="score-rank">{String(index + 1).padStart(2, '0')}</span>
        <span className="score-player"><strong>{entry.name}</strong><small>{category === 'official' ? `${entry.foodEaten} food · ${entry.seconds}s` : `${entry.board} · ${entry.speed}× · ${entry.wallMode}`}</small></span>
        <strong className="score-value">{entry.score.toLocaleString()}</strong>
      </div>)}
    </div>
  </section>
}
